import React from 'react'
import ReactDOM from 'react-dom'
import App from 'App'
import { checkVersion } from './utils/versionCheck'
import ErrorBoundary from './components/ErrorBoundary'
import './utils/errorLogger' // Инициализируем автоматическое логирование ошибок

import createRouter from 'router5'
import browserPlugin from 'router5-plugin-browser'
import { RouterProvider } from 'react-router5'

import {Provider} from "react-redux"
import store from "store"

import { bootstrapAuthFromQuery } from './methods/bootstrapSupportAuth'
import { bootstrapPartnerAuthFromQuery } from './methods/bootstrapPartnerAuth'
import { captureUtmFirstTouch } from './methods/utmFirstTouch'

async function bootstrapAuthFromUrl(): Promise<void> {
  // Диплинк техподдержки: JWT в query (синхронно).
  bootstrapAuthFromQuery()
  // Диплинк партнёра: одноразовый code → обмен на токены через API.
  await bootstrapPartnerAuthFromQuery()
}

// Полифил для Array.prototype.at()
if (!Array.prototype.at) {
    Array.prototype.at = function(n) {
        n = Math.trunc(n) || 0;
        if (n < 0) n += this.length;
        if (n < 0 || n >= this.length) return undefined;
        return this[n];
    };
}


// Create router
const UTM_PARAMS = 'utm_source&utm_medium&utm_campaign&utm_content&utm_term';

const routes = [
  { name: 'main', path: '/main?signout&auth&register&mcp_client_id&mcp_redirect_uri&mcp_code_challenge&mcp_code_challenge_method&mcp_state&mcp_scope&mcp_resource&mcp_client_name' },
  { name: 'register', path: '/register?firstName&middleName&lastName&email&phoneNumber&promoCode' },
  { name: 'another', path: '/another?signout&auth&register' },
  { name: 'new-contract', path: '/new-contract?act&templateId&newUser&open_ai_chat&ai_chat_greeting&generate_from_scratch&catalog&onboarding&demo&add_object' },
  { name: 'signed-contracts', path: '/signed-contracts' },
  { name: 'template', path: '/template/:templateId' },
  { name: 'contract', path: '/contract/:contractId?is_first_signer&additional_signer&client_preview&preview_token&as_client&demo' },
  { name: 'package', path: '/package/:packageId?as_client&demo'},
  { name: 'profile', path: '/profile?signout&loaded&success&transactionId&tab&realty_setup'},
  { name: 'invite', path: '/invite/:roleId?phone_number'},
  { name: 'shared-template', path: '/shared-template/:shareLinkId'},
  { name: 'new-pdf-contract', path: '/new-pdf-contract'},
  { name: 'contract-statistics', path: '/contract-statistics?from&to'},
  { name: 'tariffs', path: '/tariffs?add_to_cart&success&transactionId'},
  { name: 'packages-v2', path: '/packages-v2?add_to_cart&add_to_cart_tariff_id&custom_quantity&success&transactionId'},
  { name: 'contract-legal-check', path: '/contract-legal-check/:templateId'},
  { name: 'legal-help', path: '/legal-help/:contractId'},
  { name: 'closing-documents', path: '/template/:templateId/closing-documents'},
  { name: 'partner-program', path: '/partner-program' },
  { name: 'auth-partner', path: '/auth/partner' },
  { name: 'contract-branding', path: '/contract-branding?contractId&success&transactionId' },
  { name: 'debug', path: '/debug'},
];

// Добавляем UTM-параметры к каждому пути
const routesWithUtm = routes.map(route => ({
  ...route,
  path: route.path.includes('?') 
    ? `${route.path}&${UTM_PARAMS}`
    : `${route.path}?${UTM_PARAMS}`
}));

const router = createRouter(routesWithUtm, {
  defaultRoute: 'main'
})
router.usePlugin(browserPlugin())
router.useMiddleware((router) => (fromState, toState, done) => {

  if (!fromState || !toState) return done()

  if (fromState.name !== toState.name)
    window.scrollTo(0, 0)

  done()
})

async function startApp(): Promise<void> {
  // До бутстрапа: partner-auth снимает query, и первая метка иначе не доживёт до регистрации.
  captureUtmFirstTouch()
  // Обмен code → токены до checkVersion: reload при смене версии не должен
  // прерывать вход; при повторной загрузке code ещё в URL, но токен уже в storage.
  await bootstrapAuthFromUrl()
  await checkVersion()

  const appStore = store();
  (window as any).okidokiStore = appStore;

  router.start(() => {
    ReactDOM.render(
        <React.StrictMode>
          <RouterProvider router={router}>
            <Provider store={appStore}>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </Provider>
          </RouterProvider>
        </React.StrictMode>,
        document.getElementById('root')
    )
  })
}

startApp()
